<template>
  <div>
    <spacer :y="4"/>
    <loader-simple :flag="flag.loader">
      <ul v-if="!flag.loader">
        <stack-item>
          <contents-box
            title="相談履歴"
            :bg="userBoxColor(targetUser)">

            <div :class="$style.historyCount">
              <p :class="$style.historyCountTotal">実施総数　{{ historyCount.reserve.done + historyCount.text.done }} 回</p>
              <p v-if="onlineVirtualCountLabel">
                <span>{{ onlineVirtualCountLabel }}　</span>
                <span>実施 {{ historyCount.reserve.done }} 回</span>
                <span> / </span>
                <span>当日キャンセル {{ historyCount.reserve.cancelOnTheDay }} 回</span>
                <span> / </span>
                <span>事前キャンセル {{ historyCount.reserve.cancelBefore }} 回</span>
              </p>
              <p v-if="historyCount.text.done > 0">
                <span>テキスト　</span>
                <span>{{ historyCount.text.done }} 回</span>
              </p>
            </div>

            <user-box
              v-if="targetUser"
              :user="targetUser"
              :ownUser="user"
              :showId="true"
              :showCocomoniBtn="true"
            >
            </user-box>

            <spacer :y="4"/>
            <histories
              :histories="histories"
              :showNew="false"
              :hideCounseling="true"
              :riskApplications="riskApplications"
            />
          </contents-box>
        </stack-item>
      </ul>
    </loader-simple>
    <spacer :y="4"/>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Histories from '@/views/components/Histories.vue';
import ContentsBox from '@/views/components/ContentsBox.vue';
import UserBox from '@/views/components/UserBox.vue';
import StackItem from '@/views/components/StackItem.vue';
import LoaderSimple from '@/views/components/LoaderSimple.vue';
import Spacer from '@/views/components/Spacer.vue';
import cf from '@/mixins/commonFunctions.js';

export default {
  name: 'user-history',
  mixins: [cf],
  components: {
    Histories,
    ContentsBox,
    UserBox,
    StackItem,
    LoaderSimple,
    Spacer,
  },
  data() {
    return {
      flag: {
        loader: true,
      },
      slug: null,
      // reserve: null, // 不使用
      // reserves: [], // 不使用
      // texts: [], // 不使用
      // virtualReserves: [], // 不使用
      histories: [],
      riskApplications: [], // 承認された申請のみ
      targetUser: null,
    };
  },
  async created() {
    const slug = cf.convert2Num(this.$route.params.slug);
    this.slug = slug;

    // 画面表示前に取得しておきたいのでawaitで実行する
    await this.getRiskApplications();

    this.getUser();
    // this.getReserves();
    this.getHistory();
  },
  computed: {
    ...mapState(['user', 'helper']),
    reserveHistories() {
      return this.histories.filter((h) => h.type === 'reserve' || h.type === 'virtualReserve'); // オンライン/バーチャル相談履歴のみ
    },
    textHistories() {
      return this.histories.filter((h) => h.type === 'text' && h.content.flag === 11); // テキスト相談履歴のみ（実施済み）
    },
    historyCount() {
      return {
        reserve: {
          done: this.reserveHistories.filter((h) => [11].includes(h.content.flag)).length, // 実施済み
          cancelOnTheDay: this.reserveHistories.filter((h) => [902].includes(h.content.flag)).length, // 当日キャンセル
          cancelBefore: this.reserveHistories.filter((h) => [901, 903].includes(h.content.flag)).length, // 事前キャンセル
        },
        text: {
          done: this.textHistories.length,
        },
      };
    },
    onlineVirtualCountLabel() {
      const hasOnline = this.reserveHistories.some((h) => h.content._counselingType.counseling_type === 1);
      const hasVirtual = this.reserveHistories.some((h) => h.content._counselingType.counseling_type === 3);
      if (hasOnline && hasVirtual) return 'オンライン・バーチャル';
      if (hasOnline) return 'オンライン';
      if (hasVirtual) return 'バーチャル';
      return '';
    },
  },
  methods: {
    getUser() {
      const params = {
        id: this.slug,
        isRisk: 1,
        includeDeleted: 1,
        isUserWatch: 1, // UserWatchの有無
      };
      this.axios({
        method: 'GET',
        url: '/v1/user/get/detail',
        params,
      })
        .then((response) => {
          this.targetUser = response.data.data;
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          else console.log(error);
        });
    },
    getHistory() {
      const params = { userId: this.slug };

      this.axios({
        method: 'GET',
        url: '/v1/history/get/list',
        params,
      })
        .then((response) => {
          const res = response.data.data.data;
          this.histories = res.filter((elem) => elem.content.flag !== 1);
          // 下記は不使用
          // this.reserves = res.filter((elem) => (elem.type === 'reserve' && elem.content.flag === 1)); // 予約の欄に追加するのは未実施のオンラインのみ
          // this.virtualReserves = res.filter((elem) => (elem.type === 'virtualReserve' && elem.content.flag === 1)); // 同上
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
        })
        .finally(() => {
          this.flag.loader = false;
        });
    },
    // getReserves() { // 不使用
    //   const params = {
    //     from_user_id: this.slug,
    //     sort: true,
    //   };
    //   this.axios({
    //     method: 'get',
    //     url: '/v1/reserve/get/list',
    //     params,
    //   })
    //     .then((response) => {
    //       const res = response.data;
    //       this.reserves = res.reserves.data;
    //       this.getTexts();
    //     })
    //     .catch((error) => {
    //       if (error.response) console.log(error.response.data);
    //       else console.log(error);
    //     });
    // },
    // getTexts() { // 不使用
    //   const params = {
    //     user_id: this.slug,
    //     sort: true,
    //     includeDraft: 1,
    //   };
    //   this.axios({
    //     method: 'GET',
    //     url: '/v1/messagegroup/get/list',
    //     params,
    //   })
    //     .then((response) => {
    //       const res = response.data;
    //       this.texts = res.groups.data;
    //       this.sortHistories();
    //     })
    //     .catch((error) => {
    //       if (error.response) console.log(error.response.data);
    //       else console.log(error);
    //     });
    // },
    // sortHistories() { // 不使用
    //   this.histories = [];
    //   const now = this.formatTimestamp(new Date(), 'YYYY-MM-DD HH:mm:ss');
    //   this.reserves.history.forEach((row) => {
    //     const schedule = this.formatTimestamp(row.schedule.date, 'YYYY-MM-DD HH:mm:ss');
    //     if (schedule < now) {
    //       this.histories.push({
    //         date: schedule,
    //         type: 'reserve',
    //         content: row,
    //       });
    //     }
    //   });
    //   this.texts.answered.forEach((row) => {
    //     this.histories.push({
    //       date: row.created_at,
    //       type: 'text',
    //       content: row,
    //     });
    //   });
    //   this.texts.progress.forEach((row) => {
    //     this.histories.push({
    //       date: row.created_at,
    //       type: 'text',
    //       content: row,
    //     });
    //   });
    //   this.virtualReserves.history.forEach((row) => {
    //     const schedule = this.formatTimestamp(row.schedule.date, 'YYYY-MM-DD HH:mm:ss');
    //     if (schedule < now) {
    //       this.histories.push({
    //         date: schedule,
    //         type: 'virtualReserve',
    //         content: row,
    //       });
    //     }
    //   });
    //   this.histories.sort((a, b) => {
    //     if (a.date > b.date) return -1;
    //     return 1;
    //   });
    //   this.flag.loader = false;
    // },
    async getRiskApplications() {
      const STATUS_APPROVED = 100; // 承認
      try {
        const response = await this.axios({
          method: 'GET',
          url: '/v1/riskApplications/get/list',
          params: {
            statuses: [STATUS_APPROVED],
            target_user_id: this.slug,
          },
        });
        this.riskApplications = response.data.data;
      } catch (e) {
        alert('リスク報告書情報の取得に失敗しました');
        console.error(e);
      }
    },
  },
};
</script>

<style lang="scss" module>
.date {
  font-weight: bold;
}
.detail {
  li {
    font-size: 14px;
    display: flex;
    align-items: flex-start;
    .content {
      font-size: 14px;
      margin-top: 3px;
      flex: 1;
    }
    &:not(:last-child) {
      margin-bottom: 10px;
    }
    > p {
      flex: 1;
    }
  }
}
.label {
  width: 100px;
  margin-right: 20px;
}
.who5 {
  flex: 1;
  li {
    justify-content: space-between;
  }
}
.types {
  margin-right: 8px;
  &:not(:first-child) {
    &:before {
      content: "/";
    }
  }
}
.textarea {
  width: 100%;
  border-radius: 8px;
  background-color: var(--gray-sub);
  border: none;
  appearance: none;
  padding: 12px;
  outline: none;
}
.assistant {
  font-size: 12px;
  color: var(--pink);
}
.historyCount {
  font-size: 16px;
  margin-bottom: 12px;
  margin-left: 1rem;
  font-weight: bold;
  .historyCountTotal {
    font-size: 18px;
    margin-bottom: 5px;
  }
}
</style>
